export default __webpack_public_path__ + "static/media/5.1df8d5ee.png";